import {
  FETCH_ERROR,
  FETCH_START,
  FETCH_SUCCESS,
  HIDE_MESSAGE,
  SET_MENU_HEADER,
  SHOW_MESSAGE,
  SHOW_WARNING,
  TOGGLE_APP_DRAWER,
  UPDATING_CONTENT,
} from 'shared/constants/ActionTypes';

export const fetchStart = () => {
  return (dispatch) => dispatch({ type: FETCH_START });
};

export const fetchSuccess = () => {
  return (dispatch) => dispatch({ type: FETCH_SUCCESS });
};

export const showWarning = (message) => {
  return (dispatch) => dispatch({ type: SHOW_WARNING, payload: message });
};

export const updatingContent = () => {
  return (dispatch) => dispatch({ type: UPDATING_CONTENT });
};

export const fetchError = (error) => {
  return (dispatch) => dispatch({ type: FETCH_ERROR, payload: error });
};

export const showMessage = (message) => {
  return (dispatch) => dispatch({ type: SHOW_MESSAGE, payload: message });
};
export const onToggleAppDrawer = () => {
  return (dispatch) => dispatch({ type: TOGGLE_APP_DRAWER });
};

export const hideMessage = () => {
  return (dispatch) => dispatch({ type: HIDE_MESSAGE });
};

export const setMenuHeader = (type) => {
  return (dispatch) => dispatch({ type: SET_MENU_HEADER, payload: type });
};
